import React, { useState } from 'react';
import { Col, Card, Modal, Carousel } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './PeopleItem.css';


const PeopleItemPoetes = (props) => {
        
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    

    if (props.job === "poète" || props.job === "poète, chanteur" || props.job === "auteur, poète") {
        
    return (
        <Col lg={4} md={6} sm={12}>
            <Card className="hvr-float-shadow" style={{padding:"10px", marginTop:"30px", borderWidth:"5px", borderStyle:"solid", borderColor:"lightGrey"}}>
                <Card.Body>
                    <Modal show={show} onHide={handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>{props.nom}<br />{props.date}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>{props.texte}</Modal.Body>
                        <Modal.Footer>
                            <Carousel controls={false} indicators={false} style={{marginLeft:"30%", width:"100%"}}>
                                <Carousel.Item>
                                    <a href={props.miniatures[0]} target="_blank" rel="noopener noreferrer"><img src={props.miniatures[0]} style={{height:"120px", marginRight:"20px"}} alt="oeuvres" /></a>
                                    <a href={props.miniatures[1]} target="_blank" rel="noopener noreferrer"><img src={props.miniatures[1]} style={{height:"120px"}} alt="oeuvres"/></a>
                                </Carousel.Item>
                                <Carousel.Item>
                                    <a href={props.miniatures[2]} target="_blank" rel="noopener noreferrer"><img src={props.miniatures[2]} style={{height:"120px", marginRight:"20px"}} alt="oeuvres"/></a>
                                    <a href={props.miniatures[3]} target="_blank" rel="noopener noreferrer"><img src={props.miniatures[3]} style={{height:"120px"}} alt="oeuvres"/></a>
                                </Carousel.Item>
                                <Carousel.Item>
                                    <a href={props.miniatures[4]} target="_blank" rel="noopener noreferrer"><img src={props.miniatures[4]} style={{height:"120px", marginRight:"20px"}} alt="oeuvres"/></a>
                                    <a href={props.miniatures[5]} target="_blank" rel="noopener noreferrer"><img src={props.miniatures[5]} style={{height:"120px"}} alt="oeuvres"/></a>
                                </Carousel.Item>
                            </Carousel>
                        </Modal.Footer>
                    </Modal>
                    <Card.Img onClick={handleShow} src={props.photo} alt={props.nom} height="400px" style={{cursor:"pointer"}}/>
                        <Card.Title className="card-title" style={{fontFamily:"Courgette", fontSize:"1.6em"}}><br />{props.nom}</Card.Title>
                </Card.Body>
            </Card>       
        </Col>
    )
    } else {
        return null;
    }
}

export default PeopleItemPoetes;